import { SearchUserActions } from '../actions/searchUser';
import { SET_SEARCH_USER } from '../constants';

export interface SearchUserState {
  searchUser: string;
}

const initialState: SearchUserState = {
  searchUser: '',
};

export const searchUserReducer = (
  state = initialState,
  action: SearchUserActions,
): SearchUserState => {
  switch (action.type) {
    case SET_SEARCH_USER:
      return {
        ...state,
        searchUser: action.payload,
      };
    default:
      return state;
  }
};
